<template>
  <div class="login-page-wrapper d-flex align-items-center justify-content-center">
    <!-- خلفية مموهة -->
    <div class="login-overlay"></div>

    <div class="login-card shadow-lg" data-aos="zoom-in" data-aos-duration="800">
      
      <!-- 1. Header (الشعار والعنوان الرسمي) -->
      <div class="login-header text-center mb-4">
        <div class="logo-container mb-3">
            <!-- استبدل الأيقونة القديمة بشعار رسمي أو أيقونة تعبر عن النظام -->
            <div class="icon-circle">
                <i class="fas fa-user-shield"></i>
            </div>
        </div>
        <h3 class="fw-bold text-primary-dark">الدخول للنظام</h3>
        <p class="text-muted small">كنترول الشهادة الإعدادية - بوابة المدارس والمستخدمين</p>
      </div>

      <!-- 2. Login Form -->
      <form @submit.prevent="handleLogin">
        
        <!-- Error Message -->
        <div v-if="error" class="alert alert-danger d-flex align-items-center" role="alert">
            <i class="fas fa-exclamation-circle me-2"></i>
            <div>{{ error }}</div>
        </div>

        <!-- National ID Field -->
        <div class="form-group mb-3">
          <label for="national_id" class="form-label fw-bold small text-secondary">الرقم القومي / كود المستخدم</label>
          <div class="input-group">
            <span class="input-group-text bg-light border-end-0"><i class="fas fa-id-card text-primary"></i></span>
            <input 
                type="text" 
                class="form-control form-control-lg border-start-0 ps-0" 
                id="national_id" 
                v-model="email" 
                required 
                placeholder="أدخل الرقم القومي"
                dir="rtl"
            />
          </div>
        </div>

        <!-- Password Field -->
        <div class="form-group mb-4">
          <label for="password" class="form-label fw-bold small text-secondary">كلمة المرور</label>
          <div class="input-group">
            <span class="input-group-text bg-light border-end-0"><i class="fas fa-lock text-primary"></i></span>
            <input 
                type="password" 
                class="form-control form-control-lg border-start-0 ps-0" 
                id="password" 
                v-model="password" 
                required 
                placeholder="••••••••" 
            />
          </div>
        </div>
        
        <!-- Submit Button -->
        <div class="d-grid mb-3">
          <button type="submit" class="btn btn-primary-gradient btn-lg text-white fw-bold shadow-sm" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            <span v-else>تسجيل الدخول الآمن <i class="fas fa-sign-in-alt ms-2"></i></span>
          </button>
        </div>

        <!-- Footer Links -->
        <div class="text-center mt-4 pt-3 border-top">
            <router-link to="/" class="text-decoration-none text-muted small hover-gold">
                <i class="fas fa-arrow-right me-1"></i> العودة للصفحة الرئيسية
            </router-link>
            <!-- إذا كان التسجيل متاحاً للمدارس -->
            <!-- <div class="mt-2">
                <router-link :to="{ name: 'Register' }" class="text-primary fw-bold small">
                  إنشاء حساب جديد للمدرسة
                </router-link>
            </div> -->
        </div>

      </form>
      
      <!-- حقوق الملكية المصغرة -->
      <div class="text-center mt-4">
        <p class="copyright-text">جميع الحقوق محفوظة © لجنة النظام والمراقبة</p>
      </div>
      
    </div>
  </div>
</template>

<script>
import auth from '../services/auth'; // يفترض وجود هذا الملف لخدمة المصادقة
import api from '@/api/axios';

export default {
  name: 'LoginPage', // إضافة اسم للمكون ليتوافق مع التصميم
  data() {
    return {
      email: '',
      password: '',
      error: null,
      loading: false,
   
    };
  },

  mounted() {
    
    
  },
  methods: {
   

    async handleLogin() {
      // الخطوة 1: تفعيل حالة التحميل ومسح الأخطاء السابقة
      this.loading = true;
      this.error = null;

      try {
        // الخطوة 2: استدعاء خدمة المصادقة وانتظار الرد
        const data = await auth.login({ 
          email: this.email, 
          password: this.password 
        });
   

        // الخطوة 3: في حالة النجاح، يتم التوجيه بناءً على دور المستخدم
        if (data.user.role === 'admin' ) {
          this.$router.push({ name: 'AdminComplaintsDashboard' }); // أو 'Dashboard' حسب تفضيلك
        } else if (data.user.role === 'committee_head' ) {
          this.$router.push({ name: 'CommitteeDistribution' });

        } else if ( data.user.role === 'school_manager') {
           this.$router.push({ name: 'SchoolManagerInstructions' });

       } else if ( data.user.role === 'operations_admin') {
           this.$router.push({ name: 'AdminComplaintsDashboard' });
       
        } else if ( data.user.role === 'control_head') {
           this.$router.push({ name: 'StudentInquiryOn' });

       }else{
          this.$router.push('/'); 

        }

      } catch (err) {
        // الخطوة 4: في حالة الفشل، يتم عرض رسالة خطأ مناسبة للمستخدم
        // محاولة استخلاص رسالة الخطأ من الرد القادم من الـ API
        if (err.response && err.response.data && err.response.data.message) {
          this.error = err.response.data.message;
        } else {
          // رسالة خطأ عامة إذا لم تكن هناك رسالة محددة
          this.error = 'حدث خطأ أثناء تسجيل الدخول. يرجى التحقق من بياناتك والمحاولة مرة أخرى.';
        }
        // طباعة الخطأ الكامل في الكونسول للمطورين
        console.error("Login failed:", err);
        
      } finally {
        // الخطوة 5: إيقاف حالة التحميل دائمًا، سواء نجح الطلب أو فشل
        this.loading = false;
      }
    },


  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700&display=swap');

/* --- Layout & Background --- */
.login-page-wrapper {
  position: relative;
  min-height: 100vh;
  font-family: 'Cairo', sans-serif;
  /* background: url('/img/logo/bg-control.jpg') no-repeat center center fixed; */
  background-size: cover;
}

.login-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(0, 33, 71, 0.92) 0%, rgba(13, 71, 161, 0.85) 100%);
  backdrop-filter: blur(3px);
}

/* --- Login Card --- */
.login-card {
  position: relative;
  width: 100%;
  max-width: 450px;
  background: #ffffff;
  border-radius: 15px;
  padding: 2.5rem;
  border-top: 5px solid #ffc107; /* الخط الذهبي المميز */
  z-index: 2;
}

/* --- Header Icons --- */
.icon-circle {
    width: 80px;
    height: 80px;
    background: #f0f4f8;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    color: #0d47a1;
    font-size: 2.5rem;
    box-shadow: inset 0 0 10px rgba(0,0,0,0.05);
}

.text-primary-dark {
    color: #002147;
}

/* --- Form Elements --- */
.input-group-text {
    background-color: #f8f9fa;
    border-color: #ced4da;
    color: #0d47a1;
}

.form-control {
    border-color: #ced4da;
    font-size: 1rem;
}

.form-control:focus {
    box-shadow: none;
    border-color: #0d47a1;
}

.form-control:focus + .input-group-text {
    border-color: #0d47a1;
}

/* --- Buttons --- */
.btn-primary-gradient {
    background: linear-gradient(90deg, #002147 0%, #0d47a1 100%);
    border: none;
    transition: transform 0.2s;
}

.btn-primary-gradient:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(13, 71, 161, 0.3);
}

.btn-primary-gradient:disabled {
    background: #6c757d;
    transform: none;
}

/* --- Footer & Extras --- */
.hover-gold {
    transition: color 0.3s;
}
.hover-gold:hover {
    color: #ffc107 !important;
}

.copyright-text {
    font-size: 0.75rem;
    color: #adb5bd;
    margin-bottom: 0;
}
</style>